export enum ContractTypeEnums {
  Standard = 1,
  KooperationLight = 2,
  ProHolidays = 3,
}

export interface ContractType {
  id: number;
  title: string;
  is_default: boolean | null;
}
